<template>
  <div>
    <PStepper :steps="steps" :active-step="activeStep - FIRST_STEP" step-tag="h1" />
    <div class="mb-2 pt-4 text-grey-50 h-[26rem]">
      <OnboardingIntro v-if="activeStep === FIRST_STEP" />
      <OnboardingProfile v-if="activeStep === 2" />
      <OnboardingLetterFile v-if="activeStep === 3" />
      <OnboardingSignDoc v-if="activeStep === 4" />
      <OnboardingSignLF v-if="activeStep === 5" />
      <OnboardingMassSignLF v-if="activeStep === 6" />
      <OnboardingLFHome v-if="activeStep === 7" />
    </div>

    <div class="absolute bottom-4 right-4 flex gap-1 bg-white">
      <PButton
        :disabled="activeStep <= FIRST_STEP"
        @click="activeStep -= 1"
        mode="secondary"
        :data-sentry-id="`OnboardingPreviousBtn-${activeStep}`"
      >
        Précédent
      </PButton>
      <PButton
        v-if="!isLastStep"
        :disabled="isLastStep"
        @click="activeStep += 1"
        :data-sentry-id="`OnboardingNextBtn-${activeStep}`"
      >
        Suivant
      </PButton>
      <PButton v-else-if="isLastStep" @click="end" data-sentry-id="OnboardinEndBtn"> J'ai compris </PButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import OnboardingIntro from "@/app/components/Onboarding/OnboardingIntro.vue";
import OnboardingLetterFile from "@/app/components/Onboarding/OnboardingLetterFile.vue";
import OnboardingLFHome from "@/app/components/Onboarding/OnboardingLFHome.vue";
import OnboardingMassSignLF from "@/app/components/Onboarding/OnboardingMassSignLF.vue";
import OnboardingProfile from "@/app/components/Onboarding/OnboardingProfile.vue";
import OnboardingSignDoc from "@/app/components/Onboarding/OnboardingSignDoc.vue";
import OnboardingSignLF from "@/app/components/Onboarding/OnboardingSignLF.vue";
import { PButton, PStepper, type PStepperStep } from "@pasta/box-v2";
import { useAuthStore } from "@pasta/front-auth-v2";
import { computed, ref } from "vue";
import { useUserPreferencesStore } from "../../stores/user-preferences.store.ts";

const authStore = useAuthStore();
const userPreferencesStore = useUserPreferencesStore();

const steps: PStepperStep[] = [
  { title: `Bienvenue ${authStore.currentUser?.firstName},` },
  { title: "Gérer son profil" },
  { title: "Gérer un parapheur" },
  { title: "Signer un document" },
  { title: "Signer un parapheur" },
  { title: "Signer des parapheurs en bloc" },
  { title: "Retrouver rapidement ses parapheurs" },
];

const FIRST_STEP = 1;
const activeStep = ref<number>(FIRST_STEP);
const isLastStep = computed(() => activeStep.value >= steps.length);

async function end() {
  await userPreferencesStore.updateMine({ onboardingSeen: true });
  activeStep.value = FIRST_STEP;
}
</script>
